module.exports = __webpack_public_path__ + "img/suijin-chart-car-yoko.30c05f2c.png";